"use strict";
/// <reference path="irep.js"/>

IREP.LMS = (function () {
    var lmsOptions, registerSubmitAttempted = false, mergeSubmitAttempted = false;
    var init = function(options) {
        lmsOptions = options;

        $(".noAccount").click(function() {
            $(this).addClass("selectedOption");
            $(".hasAccount").removeClass("selectedOption");
            $("input:radio[name='HasAccount'][value='false']").prop("checked", true);
            $("#registerForm").slideDown();
            $("#loginForm").slideUp();
        });
        $(".hasAccount").click(function() {
            $(this).addClass("selectedOption");
            $(".noAccount").removeClass("selectedOption");
            $("input:radio[name='HasAccount'][value='true']").prop("checked", true);
            $("#registerForm").slideUp();
            $("#loginForm").slideDown();
        });

        $(".acceptTerms").click(function() {
            var termsAccepted = $("#termsAccepted");
            termsAccepted.prop("checked", !termsAccepted.prop("checked"));
        });

        var hasAccountInitialValue = $("input:radio[name='HasAccount']:checked").val();
        if (hasAccountInitialValue !== null) {

            if (hasAccountInitialValue === "true") {
                mergeSubmitAttempted = true;
            } else if (hasAccountInitialValue === "false") {
                registerSubmitAttempted = true;
            }

            validateForm().then(function() {
                if (hasAccountInitialValue === "true") {
                    $(".hasAccount").click();
                } else if (hasAccountInitialValue === "false") {
                    $(".noAccount").click();
                }
            });
        }

        $(".acceptTerms").click(function() {
            $(".checkBox").toggleClass("checked");
            registerSubmitAttempted = true;
        });

        $("#StoreId").select2({
            placeholder: options.storeName,
            minimumInputLength: (IREP.options.user.site === "ASMO" ? 1 : 2),
            quietMillis: 300,
            width: (IREP.options.user.siteName === "ASMO" ? 665 : 600),
            allowClear: true,
            formatResult: function(item, can, q) { return item.text; },
            formatSelection: function(item, can, q) {
                return item.text.replace(/<br \/>/g, " ");
            },
            ajax: {
                type: "GET",
                //url: "/ws/registration.asmx/GetIntegratedStoreListSixParams",
                url: irep.options.apiUrlSecure + "retailers/getstorelistsixparams",
                params: {
                    contentType: "application/json; charset=utf-8"
                },
                dataType: "json",
                data: function(term, page) {
                    var g = IREP.options.user.site;
                    var c = $("#CountryCode").val();
                    var r = (IREP.options.user.site === "ASMO" ? $("#ProvinceId").val() || "" : "");
                    var u = (IREP.options.user.site === "ASMO" ? $("#UserTypeId").val() || "" : "");
                    var z = ($("#Postal") ? $("#Postal").val() || '' : '');
                    var s = term;
                    var p = page;
                    return {
                        geo: g,
                        country: c,
                        search: s,
                        province: r,
                        postal: z,
                        usertype: u,
                        page: p
                    };
                },
                results: function(data, page) {
                    data = jQuery.map(
                        data.store,
                        function(x) {
                            return { id: x.id, text: x.name };
                        }
                    );
                    return { results: data, more: false };
                }
            }
        }).change(function(e) {});

        $("#CountryCode").change(function() {
            IREP.callApi({
                type: "GET",
                url: "/country/states/" + $("#CountryCode").val(),
                data: {}
            }).then(function(data) {
                $("#ProvinceId").empty();
                _.forEach(data.states, function(state) {
                    $("#ProvinceId").append("<option value='" + state.id + "'>" + state.name + "</option>");
                });
            });
        });

        $("form")
            .on("change", "input,select", validateForm)
            .on("click", ".acceptTerms", validateForm)
            .on("click", "button.continueBtn", function() {
                var form = $(this).parents("form");
                mergeSubmitAttempted = true;
                validateForm().then(function(ok) {
                    if (ok === true) {
                        form.submit();
                    } else {
                        // validation failed...
                    }
                });
                return false;
            });
    };

    var validateForm = function() {
        var hasAccount = $("input:radio[name='HasAccount']:checked").val() === "true";
        var formSelector = "";
        var isValid;

        $(".errors", formSelector).remove();

        if (hasAccount) {
            formSelector = "#loginForm";
            isValid = validateMergeForm(formSelector);
        } else {
            formSelector = "#registerForm";
            isValid = validateRegisterForm(formSelector);
        }

        return isValid.then(function(ok) {
            var submitButton = $("button.continueBtn", formSelector);
            if (ok === true) {
                submitButton.removeAttr("disabled");
            } else if (hasAccount === false) {
                submitButton.attr("disabled", "disabled");
            }

            return ok;
        });
    };

    var validateRegisterForm = function (formSelector) {
        var isValid = true;
        var requiredTextAndDropdownFields = $("input[type='text'][required], input[type='hidden'][required], select[required]", formSelector);
        var requiredRadioGroups = _.uniq($("input[type='radio'][required]", formSelector).map(function (i, el) { return el.name; }));
        var emailRegex = /\w+([-+.'\w]+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/gi;

        var userName = $("#UserName", formSelector);
        var checkUsernameExists;

        if (!_.isEmpty(userName.val()) && userName.val().match(emailRegex) === null) {
            checkUsernameExists = {};
            isValid = false;
            addErrorMessage(userName, lmsOptions.errorMsgEmail, registerSubmitAttempted);
        }
        else if (_.isEmpty(userName.val())) {
            checkUsernameExists = {};
        } else {
            checkUsernameExists = IREP.callApi({ url: "participant/username/exists", type: "POST", data: { username: userName.val(), paxuid: IREP.options.user.currentUID } })
                .then(function(data) {
                    if (data.exists) {
                        isValid = false;
                        addErrorMessage(userName, lmsOptions.errorMsgEmailExists, true);
                    }
                    return data.exists === false;
                });
        }
        var password = $("#Password"), confirmPassword = $("#ConfirmPassword");
        if (password.val() !== confirmPassword.val()) {
            isValid = false;
            addErrorMessage(password, lmsOptions.passwordsDontMatch, registerSubmitAttempted);
        } else if (!IREP.Password.validateComplexity(password.val())) {
            isValid = false;
            addErrorMessage(password, lmsOptions.passwordComplexity, registerSubmitAttempted);
        }

        _.each(requiredTextAndDropdownFields, function (field) {
            var $field = $(field);
            if (_.isEmpty($field.val()) || $field.val() === "-1" || $field.val() === "0") {
                isValid = false;
                addErrorMessage($field, $field.data("valRequired"), registerSubmitAttempted);
            }
        });

        _.each(requiredRadioGroups, function(radioGroupName) {
            var $group = $("input:radio[name='" + radioGroupName + "']", formSelector);
            if ($group.filter(":checked").length !== 1) {
                isValid = false;
                var lastOption = $($group[$group.length - 1]);
                addErrorMessage(lastOption.parents("label"), lastOption.data("valRequired"), registerSubmitAttempted, true);
            }
        });

        var phoneFormatOptions = {};

        switch (IREP.options.user.site) {
            case "ASMO":
                phoneFormatOptions = {
                    message: "* (###) ###-####",
                    formatExpression: /^\(?\d\d\d\)?(\s+|-)?\(?\d\d\d?\)?(\s+|-)?\(?\d\d\d\d\)?$/
                }
                break;
        }

        if (!_.isEmpty(phoneFormatOptions)) {
            _.each(["Phone", "CellPhone"], function(id) {
                var phone = $("#" + id, formSelector);
                if (!_.isEmpty(phone.val()) && phone.val().match(phoneFormatOptions.formatExpression) === null) {
                    isValid = false;
                    addErrorMessage(phone, phoneFormatOptions.message, registerSubmitAttempted);
                }
            });
        }
        var termsCheckbox = $(".acceptTerms", formSelector);
        var termsAccepted = termsCheckbox.find(".checkBox").hasClass("checked");
        if (!termsAccepted) {
            isValid = false;
            addErrorMessage(termsCheckbox, "* ", registerSubmitAttempted, true);
        }

        return $.when(checkUsernameExists, isValid).then(function (usernameExists, fieldsValid) {
            return usernameExists && fieldsValid;
        });
    };

    var validateMergeForm = function(formSelector) {
        var username = $("#UserName", formSelector).val();
        var password = $("#Password", formSelector).val();
        var isValid = true;
        
        if (_.isEmpty(username) || _.isEmpty(password)) {
            addErrorMessage($(formSelector).find(".fieldContainer"), lmsOptions.usernameAndPasswordRequired, mergeSubmitAttempted);
            isValid = false;
        }

        return $.when(isValid);
    };


    var addErrorMessage = function (field, message, showError, useSpan) {
        if (showError === true) {
            field.after($("<" + (useSpan === true ? "span" : "div") + ">", { "class": "errors" }).html(message));
        }
    };

    return {
        init: init
    };
})();

IREP.Password = (function() {
    var upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var lower = upper.toLowerCase();
    var number = "1234567890";
    var special = "|[!\"#$%&'()*+,-./:;=>?@[\]^_`{|}~]";

    var validateComplexity = function (password) {
        return !(password.length < 6 || !(containsChars(password, upper) || containsChars(password, lower)) || !containsChars(password, number) || !containsChars(password, special));
    };

    var containsChars = function(password, validChars) {
        for (var i = 0; i < password.length; i++) {
            var char = password.charAt(i);
            if (validChars.indexOf(char) > -1) {
                return true;
            }
        }
        return false;
    };

    return { validateComplexity: validateComplexity };
})();